import Head from 'next/head';
import { useRouter } from 'next/router';
import { DEFAULT_OG_IMG_URL } from '../../../constants';
import { Seo } from '../../../models/Seo';

type Props = {
  seo: Seo
}

const SeoHead: React.FC<Props> = ({ seo }) => {
  const {
    metaTitle,
    metaDescription,
    preventIndexing,
    keywords,

  } = seo;
  const router = useRouter();
  const { shareImage } = seo;
  let img = DEFAULT_OG_IMG_URL;
  if (shareImage && shareImage.media) {
    img = shareImage.media.url;
  }

  return (
    <Head >
      <title>{metaTitle}</title>
      <meta property="description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={`https://codealo.dev${router.asPath}`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="es" />
      <meta name="keywords" content={keywords} />
      {preventIndexing && <meta name="robots" content="noindex" />}
    </Head>
  )
}


export default SeoHead;